module.exports = __webpack_public_path__ + "static/img/tips2.f5433d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tips2.png
// module id = 2592
// module chunks = 0